import { render, staticRenderFns } from "./managemenus.vue?vue&type=template&id=c7edfe64&scoped=true&"
import script from "./managemenus.vue?vue&type=script&lang=js&"
export * from "./managemenus.vue?vue&type=script&lang=js&"
import style0 from "./managemenus.vue?vue&type=style&index=0&id=c7edfe64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7edfe64",
  null
  
)

export default component.exports